import { useEffect, useState } from 'react';
import {
    fetchForecastData,
    fetchMapRegionsGeoJson,
    fetchSitesData,
    fetchSitesPerRegion
} from "../../api/data";
import ForecastAirQualityDisplay from '../displays/ForecastAirQualityDisplay';
import CurrentAirQualityDisplay from '../displays/CurrentAirQualityDisplay';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';


function CurrentAndForecastAirQualityDisplays({ data }) {
    const [activeTab, setActiveTab] = useState("forecastTab");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [forecastData, setForecastData] = useState({});
    const [mapRegions, setMapRegions] = useState({});
    const [sitesData, setSitesData] = useState({});
    const [sitesPerRegion, setSitesPerRegion] = useState({});

    const today = moment();

    useEffect(() => {
        fetchForecastData()
            .then(data => {
                setForecastData(data);
            })
            .catch(err => {
                console.error("Could not load forecast data");
                setLoading(false);
                setError(true);
            });
        fetchMapRegionsGeoJson()
            .then(data => {
                setMapRegions(data);
            })
            .catch(err => {
                console.error("Could not load map regions geojson data");
                setLoading(false);
                setError(true);
            });
        fetchSitesData()
            .then(data => {
                setSitesData(data);
            })
            .catch(err => {
                console.error("Could not load sites data");
                setLoading(false);
                setError(true);
            });
        fetchSitesPerRegion()
            .then(data => {
                setSitesPerRegion(data);
            })
            .catch(err => {
                console.error("Could not load sites per region data");
                setLoading(false);
                setError(true);
            });
    }, []);

    useEffect(() => {
        if (Object.keys(forecastData).length > 0
              && Object.keys(mapRegions).length > 0
              && Object.keys(sitesData).length > 0
              && Object.keys(sitesPerRegion).length > 0) {
            setLoading(false);
        }
    }, [forecastData, mapRegions, sitesData, sitesPerRegion]);


    if (loading) return <div key={data.documentId}>Loading...</div>;
    if (error) return <div key={data.documentId}>Error</div>;

    const toggleTabs = (e) => {
        e.preventDefault();
        let target = e.target;
        let tagName = target.tagName.toLowerCase();
        if (tagName === "font") {
            target = target.closest(".nav-link");
            tagName = target.tagName.toLowerCase();
        }
        if (tagName === "li") {
            target = target.children[0];
        } // else is "a"
        if (target.id !== activeTab) {
            setActiveTab(target.id);
        }
    };

    return (
        <div key={data.documentId} className="current-and-forecast-air-quality-displays">
            <div className="col-sm-10 col-xs-12 air-quality-container" style={{ position: "relative" }}>

                <div>

                    <ul className="nav nav-buttons flex-column air-tabs nav-fill">
                        <li className={"nav-item aqiTab " + (activeTab === "forecastTab" ? "active" : "")} onClick={ (e) => toggleTabs(e) }>
                            <a className="nav-link" href="#forecasts" id="forecastTab" data-toggle="tab">Forecasts</a>
                        </li>
                        <li className={"nav-item aqiTab " + (activeTab === "currentTab" ? "active" : "")}  onClick={ (e) => toggleTabs(e) } style={{ clear: "both" }}>
                            <a className="nav-link" href="#current" id="currentTab" data-toggle="tab" data-tab="current">Current</a>
                        </li>
                    </ul>

                    <div className="loader" hidden={ true }></div>

                    <div className="tab-content clearfix display-container">

                        <ForecastAirQualityDisplay
                            aqiCategoryIcons={ data.forecastIcons.forecast_icon_set_item.icons }
                            forecastData={ forecastData }
                            mapRegions={ mapRegions }
                            isActive={ activeTab === "forecastTab" }
                            today={ today }
                        />

                        <CurrentAirQualityDisplay
                            aqiCategoryIcons={ data.forecastIcons.forecast_icon_set_item.icons }
                            sitesData={ sitesData }
                            sitesPerRegion={ sitesPerRegion }
                            mapRegions={ mapRegions }
                            isActive={ activeTab === "currentTab" }
                            today={ today }
                        />

                    </div>

                </div>

            </div>
        </div>
    );
}

export default CurrentAndForecastAirQualityDisplays;
